
export default {
  jsonData: {
    data: {},
  },
  settings: {
    showOnlyMatchedProperties: false,
    highlightColor: '#b6f5ff',
    expandAll: false,
  }
}